import React, { useState } from 'react';
import PermissionTemplateManager from '../components/PermissionTemplateManager';
import UserPermissionAssignment from '../components/UserPermissionAssignment';

const PermissionManagementPage = () => {
    const [activeTab, setActiveTab] = useState('templates');

    return (
        <div className="permission-management-page">
            <div className="page-header">
                <h1>Permission Management System</h1>
                <p>Manage permission groups and assign them to users through a checkbox interface.</p>
            </div>

            <div className="tab-navigation">
                <button 
                    className={`tab-button ${activeTab === 'templates' ? 'active' : ''}`}
                    onClick={() => setActiveTab('templates')}
                >
                    Permission Groups
                </button>
                <button 
                    className={`tab-button ${activeTab === 'assignments' ? 'active' : ''}`}
                    onClick={() => setActiveTab('assignments')}
                >
                    User Assignments
                </button>
            </div>

            <div className="tab-content">
                {activeTab === 'templates' && <PermissionTemplateManager />}
                {activeTab === 'assignments' && <UserPermissionAssignment />}
            </div>

            <style jsx>{`
                .permission-management-page {
                    min-height: 100vh;
                    background-color: #f5f5f5;
                    padding: 20px;
                }

                .page-header {
                    text-align: center;
                    margin-bottom: 30px;
                    padding: 20px;
                    background: white;
                    border-radius: 8px;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                }

                .page-header h1 {
                    margin: 0 0 10px 0;
                    color: #333;
                    font-size: 2.5rem;
                }

                .page-header p {
                    margin: 0;
                    color: #666;
                    font-size: 1.1rem;
                }

                .tab-navigation {
                    display: flex;
                    justify-content: center;
                    margin-bottom: 30px;
                    border-radius: 8px;
                    background: white;
                    padding: 5px;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                    max-width: 600px;
                    margin-left: auto;
                    margin-right: auto;
                    margin-bottom: 30px;
                }

                .tab-button {
                    flex: 1;
                    padding: 15px 30px;
                    border: none;
                    background: transparent;
                    color: #666;
                    font-size: 16px;
                    font-weight: 500;
                    cursor: pointer;
                    border-radius: 6px;
                    transition: all 0.3s ease;
                }

                .tab-button:hover {
                    background: #f0f0f0;
                    color: #333;
                }

                .tab-button.active {
                    background: #4472C4;
                    color: white;
                    box-shadow: 0 2px 8px rgba(68, 114, 196, 0.3);
                }

                .tab-content {
                    animation: fadeIn 0.3s ease-in-out;
                }

                @keyframes fadeIn {
                    from {
                        opacity: 0;
                        transform: translateY(10px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                @media (max-width: 768px) {
                    .permission-management-page {
                        padding: 10px;
                    }
                    
                    .page-header h1 {
                        font-size: 2rem;
                    }
                    
                    .tab-navigation {
                        flex-direction: column;
                        max-width: 100%;
                    }
                    
                    .tab-button {
                        margin-bottom: 5px;
                    }
                }
            `}</style>
        </div>
    );
};

export default PermissionManagementPage;
